import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import * as colors from '../../../constants/colors'

const ID = 'mastodon-third-party-glyph-icon'

export function MastodonSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <g clipPath="url(#mastodon-a)">
          <path d="M30.894 7.085c-.463-3.439-3.46-6.148-7.012-6.673-.599-.09-2.87-.412-8.13-.412h-.039c-5.262 0-6.39.323-6.99.412-3.453.51-6.607 2.945-7.372 6.424-.368 1.713-.407 3.613-.339 5.355.097 2.499.116 4.993.343 7.481a35.19 35.19 0 0 0 .82 4.908c.727 2.981 3.67 5.463 6.556 6.475a17.585 17.585 0 0 0 9.592.506 14 14 0 0 0 1.037-.284c.774-.245 1.68-.52 2.346-1.003a.075.075 0 0 0 .03-.058v-2.412a.072.072 0 0 0-.027-.055.07.07 0 0 0-.06-.013 26.586 26.586 0 0 1-6.224.727c-3.608 0-4.578-1.712-4.856-2.425a7.511 7.511 0 0 1-.422-1.91.069.069 0 0 1 .026-.058.069.069 0 0 1 .062-.014c2.005.484 4.06.728 6.122.727.496 0 .991 0 1.487-.013 2.074-.058 4.26-.164 6.302-.563.05-.01.102-.018.145-.032 3.22-.618 6.283-2.558 6.594-7.471.012-.193.041-2.026.041-2.227.001-.682.22-4.839-.032-7.393Z" />
          <path
            fill={colors.PRIMARY_GREY_000}
            d="M25.794 10.947v8.542h-3.385V11.2c0-1.745-.727-2.635-2.207-2.635-1.626 0-2.44 1.053-2.44 3.133v4.537h-3.366v-4.538c0-2.08-.816-3.132-2.442-3.132-1.47 0-2.205.89-2.205 2.635v8.29H6.365v-8.542c0-1.745.446-3.131 1.337-4.16.92-1.025 2.125-1.551 3.622-1.551 1.733 0 3.042.666 3.915 1.997l.842 1.414.844-1.414c.873-1.33 2.182-1.997 3.911-1.997 1.496 0 2.702.526 3.624 1.552.89 1.027 1.335 2.413 1.334 4.16Z"
          />
        </g>
        <defs>
          <clipPath id="mastodon-a">
            <path fill={colors.PRIMARY_GREY_000} d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </g>
    </symbol>
  )
}

const MastodonStandaloneContent = standalone(MastodonSymbol, ID)

export const Mastodon = styled(function MastodonStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-mastodon">
      <MastodonStandaloneContent />
    </Icon>
  )
})``

export const MastodonLightweight = styled(function MastodonComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-mastodon">
      {lightweight(ID)}
    </Icon>
  )
})``
